export default "__VITE_ASSET__DyTzQSdS__"